<template>
    <div>
      <navcon></navcon>
      <img src="../assets/img/indexBackground.png" style="width: 100%;"/>
      <CopyrightIcp></CopyrightIcp>
    </div>
</template>
<script type="text/ecmascript-6">
import navcon from '../components/navcon.vue'
import CopyrightIcp from '../components/copyright-icp.vue';

export default {
  name: 'login',

  data() {
    return {
      
    }
  },
  // 注册组件
  components: {
     navcon,CopyrightIcp
  },
  // 创建完毕状态(里面是操作)
  created() {

  },
  // 里面的函数只有调用才会执行
  methods: {
    
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/login.vue